const buttonFileDownBtn = {
  text: 'Baixar Relatório ZIP (max. 10)'
};

export default buttonFileDownBtn;
